import { useEffect } from 'react';

import { subscribe, unsubscribe } from 'pubsub-js';

export const useSubscribe = (topic, subscriber, enable = true) => {
  useEffect(() => {
    let token;

    if (enable) {
      token = subscribe(topic, subscriber);
    }

    return () => {
      if (token !== undefined) {
        unsubscribe(token);

        token = undefined;
      }
    };
  }, [topic, subscriber, enable]);
};
